import React, { Fragment } from 'react';
import { Text } from '@chakra-ui/core';
import { useTranslation } from 'react-i18next';

type ShowSalaryRangeProps = {
  minSalary: number;
  maxSalary: number;
  unit: string;
  customUnit: string;
};

export const ShowSalaryRange = ({ minSalary, maxSalary, unit, customUnit }: ShowSalaryRangeProps): JSX.Element => {
  const { t, i18n } = useTranslation();

  return (
    <>
      <Text as="span">$</Text>
      <Text as="span" mr="2">
        {minSalary.toLocaleString(i18n.language, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
      </Text>

      {maxSalary ? (
        <Fragment>
          <Text as="span" mr="2">
            -
          </Text>
          <Text as="span" mr="2">
            {maxSalary.toLocaleString(i18n.language, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </Text>
        </Fragment>
      ) : null}

      <Text as="span">/</Text>
      <Text as="span" ml="2">
        {unit === 'custom' ? customUnit : t(unit.toLowerCase())}
      </Text>
    </>
  );
};
